var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaamarim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,83.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 734 c-21 -33 -22 -32 54 -35 66 -3 78 4 80 49 2 27 -115 15 -134 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 632 c-26 -28 -21 -33 31 -30 39 3 47 6 47 23 0 28 -55 33 -78 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 631 c-16 -30 -14 -31 50 -31 57 0 60 1 60 25 0 34 -92 38 -110 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 369 l0 -259 80 0 80 0 0 261 0 260 -80 -2 -80 -2 0 -258z m128 164 c-4 -22 -35 -27 -72 -13 -39 14 -23 30 30 30 38 0 45 -3 42 -17z m2 -348 c25 -30 4 -46 -52 -43 -67 4 -79 38 -18 49 55 10 57 10 70 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 320 l0 -211 73 3 72 3 3 208 2 207 -75 0 -75 0 0 -210z m114 -146 c9 -24 -2 -34 -37 -34 -41 0 -62 14 -54 34 9 22 82 22 91 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 323 l2 -208 75 0 75 0 3 208 2 207 -79 0 -80 0 2 -207z m115 85 c-3 -31 -6 -33 -46 -36 -47 -4 -61 12 -42 47 8 16 20 21 51 21 39 0 40 -1 37 -32z m7 -243 c0 -33 -99 -30 -103 3 -3 22 -1 23 50 20 45 -3 53 -6 53 -23z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,83.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365 733 c-25 -38 -25 -38 47 -43 82 -6 98 2 101 46 2 29 2 29 -60 32 -61 3 -62 3 -88 -35z m144 15 c-2 -45 -14 -52 -80 -49 -76 3 -75 2 -54 35 19 29 136 41 134 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 632 c-37 -39 -35 -42 33 -42 33 0 60 3 60 8 0 4 -22 5 -50 4 -53 -4 -62 4 -32 31 24 22 68 22 82 0 10 -16 10 -16 8 2 -5 34 -67 33 -101 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 635 c-19 -42 -15 -45 58 -45 70 0 70 0 70 35 0 35 0 35 -58 35 -53 0 -60 -2 -70 -25z m118 -10 c0 -24 -3 -25 -60 -25 -64 0 -66 1 -50 31 18 32 110 28 110 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 375 c0 -304 -8 -282 104 -277 l76 4 0 269 0 269 -90 0 -90 0 0 -265z m170 -4 l0 -261 -80 0 -80 0 0 259 0 258 80 2 80 2 0 -260z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 540 c-8 -12 41 -32 69 -28 12 2 22 11 24 21 4 19 -81 26 -93 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 191 c-61 -11 -49 -45 18 -49 56 -3 77 13 52 43 -13 16 -15 16 -70 6z m60 -26 c0 -17 -74 -22 -84 -6 -9 14 6 21 46 21 27 0 38 -4 38 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 340 c0 -135 2 -190 3 -122 2 67 2 177 0 245 -1 67 -3 12 -3 -123z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 323 l3 -218 80 0 80 0 3 218 2 217 -85 0 -85 0 2 -217z m156 0 l-3 -208 -72 -3 -73 -3 0 211 0 210 75 0 75 0 -2 -207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 174 c-8 -20 13 -34 54 -34 35 0 46 10 37 34 -9 22 -82 22 -91 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 335 c0 -113 2 -212 5 -220 8 -19 144 -21 162 -3 9 9 12 72 12 220 l0 208 -90 0 -89 0 0 -205z m167 -12 l-3 -208 -75 0 -75 0 -2 208 -2 207 80 0 79 0 -2 -207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 419 c-19 -35 -5 -51 42 -47 40 3 43 5 46 36 3 31 2 32 -37 32 -31 0 -43 -5 -51 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 168 c4 -33 103 -36 103 -3 0 17 -8 20 -53 23 -51 3 -53 2 -50 -20z m98 -3 c0 -11 -12 -15 -45 -15 -33 0 -45 4 -45 15 0 11 12 15 45 15 33 0 45 -4 45 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 43 c24 -2 62 -2 86 0 23 2 4 4 -43 4 -47 0 -66 -2 -43 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 43 c26 -2 68 -2 95 0 26 2 4 3 -48 3 -52 0 -74 -1 -47 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 43 c23 -2 61 -2 85 0 23 2 4 4 -43 4 -47 0 -66 -2 -42 -4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,83.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335 700 c-10 -16 17 -21 86 -17 64 3 64 3 -9 5 -46 1 -71 6 -67 12 3 6 4 10 1 10 -3 0 -8 -5 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748 694 c22 -15 22 -18 24 -297 l3 -282 2 279 c3 290 0 316 -41 316 -6 0 0 -7 12 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 637 c-18 -18 -32 -36 -32 -40 0 -4 14 9 32 29 27 31 36 35 69 32 21 -2 35 0 33 4 -13 21 -71 7 -102 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 663 c57 -4 57 -4 61 -41 4 -37 4 -37 3 3 -1 40 -1 40 -61 41 -60 1 -60 1 -3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 375 c0 -148 2 -211 3 -138 2 72 2 194 0 270 -1 76 -3 17 -3 -132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 374 c-2 -259 1 -284 32 -284 5 0 2 6 -7 13 -15 11 -17 42 -20 272 l-2 260 -3 -261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 332 c0 -254 -4 -243 95 -240 70 2 70 2 -5 7 l-75 6 -3 217 -2 217 87 4 c88 3 88 3 -4 5 l-93 2 0 -218z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 543 c26 -2 68 -2 95 0 26 2 4 3 -48 3 -52 0 -74 -1 -47 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 174 c-13 -14 6 -24 44 -24 28 0 39 4 39 15 0 15 -69 22 -83 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 165 c0 -11 12 -15 45 -15 33 0 45 4 45 15 0 11 -12 15 -45 15 -33 0 -45 -4 -45 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 110 c-5 -5 -43 -11 -84 -13 l-75 -3 76 -2 c58 -2 80 2 89 13 14 17 10 21 -6 5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,83.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322 750 c-22 -39 -24 -40 -78 -40 -70 0 -83 -7 -144 -81 -50 -60 -50 -60 -50 -285 0 -299 1 -301 152 -290 40 3 81 5 91 5 21 -1 211 -1 235 0 9 0 53 -2 96 -5 146 -10 146 -11 146 346 0 329 5 315 -120 308 -70 -4 -70 -4 -70 39 0 43 0 43 -117 43 -118 0 -118 0 -141 -40z m203 3 c-3 -10 -9 -30 -12 -45 -5 -28 -6 -28 -88 -28 -98 0 -101 2 -68 51 26 39 26 39 100 39 67 0 74 -2 68 -17z m-257 -125 c3 -38 3 -38 -67 -38 -81 0 -83 2 -39 47 48 50 102 45 106 -9z m460 0 c3 -38 3 -38 -77 -38 -45 0 -81 2 -81 5 0 11 26 61 35 68 5 4 35 6 65 5 55 -3 55 -3 58 -40z m-218 -251 c0 -191 -3 -266 -12 -275 -16 -16 -160 -16 -176 0 -13 13 -18 519 -5 531 3 4 48 7 100 7 l93 0 0 -263z m-240 -51 c0 -255 8 -236 -94 -236 -89 0 -86 -8 -86 242 l0 218 90 0 90 0 0 -224z m460 6 c0 -156 -3 -221 -12 -230 -19 -19 -154 -16 -162 4 -3 9 -6 112 -6 230 l0 214 90 0 90 0 0 -218z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaamarim);
export default __webpack_public_path__ + "static/media/maamarim.05564ad6cc8f02731e8218eda013f3a1.svg";
export { ForwardRef as ReactComponent };